import React from "react";
import { Typography } from "@mui/material";

import { Chip, Tooltip } from "./BetaNotification.styles";

const BetaNotification: React.FC = () => {
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2">Beta Program</Typography>
          Market Lens will be released soon. Try this feature in beta and share your feedback!
        </>
      }
    >
      <Chip label="BETA" variant="filled" size="medium" color="secondary" />
    </Tooltip>
  );
};

export default BetaNotification;
